import React, { FunctionComponent } from "react"
import FancyLoader from "src/components/common/Loaders/FancyLoader/FancyLoader"
import "./FirstLoadLoader.css"


const FirstLoadLoader: FunctionComponent<{}> = () => {
    return (
        <div className="FirstLoadLoader">
            <FancyLoader
                className="FancyLoaderLock"
                id="eala-first-load-loader"
            />
            <p>Fetching EALA's</p>
        </div>
    )
}

export default FirstLoadLoader